module.exports = __webpack_public_path__ + "media/images/blaueskreuz-musub-logo-567a8eac4916e969012e6eea3a2d759e.jpg";